import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/public/BreakingTicker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/public/PublicHeader.tsx");
